import { Link } from "react-router-dom";

const Aside = () => {
  return (
    <>
      <ul className="aside-links">
        <li className="aside-links__item">
          <Link className="aside-links__link" to="/autopayment">
            Автоплатеж
          </Link>
        </li>
        <li className="aside-links__item">
          <Link className="aside-links__link" to="/profile">
            Профайл пользователя
          </Link>
        </li>
        <li className="aside-links__item">
          <Link className="aside-links__link" to="/contract">
            Данные договора
          </Link>
        </li>
        <li className="aside-links__item">
          <Link className="aside-links__link" to="/password">
            Изменить пароль
          </Link>
        </li>
      </ul>
    </>
  );
};

export default Aside;
